import { render } from "./MouthSmell.vue?vue&type=template&id=f1f21338"
import script from "./MouthSmell.vue?vue&type=script&lang=js"
export * from "./MouthSmell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__